module.exports = __webpack_public_path__ + "static/media/bulle_discovery_FR_3.4e30e677.png";